import './scss/cookie.scss'

//script
import './app/vue/cookie/index.js'
